module.exports = __webpack_public_path__ + "static/media/logo.73719302.png";